import fetch from "isomorphic-unfetch";
import { CURRENCY_TO_COUNTRY_CODE } from "@lib/constants";
import { resolveStorefrontToken } from "@hooks/index";

const mediaFieldsByType = `
fragment mediaFieldsByType on Media {
  ...on MediaImage {
    id
    image {
      originalSrc
      placeholder: transformedSrc(maxWidth: 100, preferredContentType: JPG)
    }
  }
  ...on Video {
    id
    previewImage {
      placeholder: transformedSrc(maxWidth: 100, preferredContentType: JPG)
      w800: transformedSrc(maxWidth: 800,  preferredContentType: JPG)
      w1200: transformedSrc(maxWidth: 1200,  preferredContentType: JPG)
      w1600: transformedSrc(maxWidth: 1600,  preferredContentType: JPG)
    }
    sources {
      url
      mimeType
      format
      height
      width
    }
  }
}`;

export const queryProducts = `
query products($handle: String!, $countryCode: CountryCode) @inContext(country: $countryCode) {
    productByHandle(handle: $handle) {
        id
        handle
        tags
        description
        availableForSale
        vendor
        totalInventory
        options {
          name
          values
        }
        media(first: 20) {
          edges {
            node {
              mediaContentType
              alt
              ...mediaFieldsByType
            }
          }
        }
        variants(first: 50) {
            edges {
                node {
                    id
                    title
                    sku
                    selectedOptions {
                        name
                        value
                    }
                    availableForSale
                    quantityAvailable
                    priceV2 {
                      amount
                      currencyCode
                    }
                    compareAtPriceV2 {
                      amount
                      currencyCode
                    }
                }
            }
        }
    }
}
${mediaFieldsByType}
`;

function formatVariant(variant) {
  return {
    ...variant,
  };
}

function formatProduct(product) {
  return {
    ...product,
    variants: product.variants.edges.map((item) => formatVariant(item.node)),
  };
}

async function fetchVariants(handle, currency, locale) {
  const { storefront_uri, access_token  } = resolveStorefrontToken();

  // FIND ME HIDE GB STUFF - this is just to force the uk inventory because there is some race condition fetching currency
  if (locale === "gb") {
    currency = "GBP";
  }

  try {
    const response = await fetch(storefront_uri, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": access_token
      },
      body: JSON.stringify({
        query: queryProducts,
        variables: { handle: handle, countryCode: CURRENCY_TO_COUNTRY_CODE[currency] },
      }),
    });

    if (!response.ok) {
      throw Error(response.statusText);
    }

    const { data } = await response.json();
    return data.productByHandle ? formatProduct(data.productByHandle) : null;
  } catch (err) {
    console.log("[fetch-variants] Error", err);
    throw err;
  }
}

// STARTS HERE
export async function fetchAllVariants(productHandles, currency, locale) {
  const promises = [];
  try {
    productHandles.forEach((productHandle) => {
      if (productHandle) promises.push(fetchVariants(productHandle, currency, locale));
    });
    return await Promise.all(promises);
  } catch (err) {
    console.log("[fetch-allVariants] Error", err);
    return [];
  }
}
